import React from "react"
import { connectSearchBox } from "react-instantsearch-dom"
import { FaSearch } from "react-icons/fa"

export default connectSearchBox(
  ({ refine, currentRefinement, className, onFocus }) => (
    <form
      className={className + " group flex flex-row-reverse items-center mb-0"}
    >
      <input
        className="SearchInput w-0 -ml-8 pl-8 cursor-pointer bg-transparent outline-none transition-all border-none"
        type="text"
        placeholder="Search"
        aria-label="Search"
        onChange={e => refine(e.target.value)}
        value={currentRefinement}
        onFocus={onFocus}
      />
      <FaSearch
        className={`SearchIcon text-black group-hover:text-red w-6 m-1 pointer-events-none text-2xl xl:text-xl`}
      />
    </form>
  )
)
